import { render, staticRenderFns } from "./AddNewAgent.vue?vue&type=template&id=0f0ab60a&"
import script from "./AddNewAgent.vue?vue&type=script&lang=js&"
export * from "./AddNewAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports